import { FC } from 'react'
import { Layout } from 'components/Layout'
import { TodayStockTemplate } from 'components/Templates'

const UnreleasedStock: FC = () => {
  return (
    <Layout headline={'在庫の増減と通知'} iconPath={'/icon/white/stock.svg'} title={'本日の在庫を編集する | 未販売'}>
      <TodayStockTemplate page={'unreleased'} />
    </Layout>
  )
}

export default UnreleasedStock
